import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, Popup } from 'semantic-ui-react';

import { AppDispatch, RootState } from '../application/store';
import { User } from '../model/User';

import { selectUsers, unselectUsers } from './users/reducer.Users';

interface HeaderCheckboxProps {
    rowsCount: number;
}

function HeaderCheckbox(props: HeaderCheckboxProps) {
    const dispatch = useDispatch<AppDispatch>();
    const { selectedUsers, currentPage } = useSelector(
        (state: RootState) => state.persistedReducers.users.userList,
    );
    const externalUsers = currentPage.list.filter((user: User) => !user.ldapId);

    const { rowsCount } = props;

    return (
        <Popup
            content={'Cannot perform any action on Active Directory users'}
            disabled={rowsCount > 0}
            trigger={
                <Checkbox
                    indeterminate={selectedUsers.length > 0 && rowsCount !== selectedUsers.length}
                    disabled={rowsCount === 0}
                    checked={rowsCount > 0 && rowsCount === selectedUsers.length}
                    onChange={(event, data) => {
                        if (data.checked) {
                            dispatch(selectUsers(externalUsers));
                        } else {
                            dispatch(unselectUsers(externalUsers));
                        }
                    }}
                />
            }
        />
    );
}

export default HeaderCheckbox;
